import React from "react";
import Skeleton from "react-loading-skeleton";
import styled from "styled-components";

export const Loader: React.FC = () => {
  return (
    <Container>
      <Top>
        <Skeleton height={15} width={90} />
        <Skeleton height={45} width={70} />
      </Top>
      <Divider />
      <Bottom>
        {Array.from({ length: 3 }, (_, i) => i).map((idx) => (
          <BottomItem key={`stats-mobile-loader-${idx}`}>
            <Skeleton height={16} width={70} />
            <Skeleton height={30} width={40} />
            <Skeleton height={16} width={60} />
          </BottomItem>
        ))}
      </Bottom>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const Top = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

const Divider = styled.div`
  background: var(--border-color);
  height: 1px;
  width: 100%;
  margin: 5px 0 10px;
`;

const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
`;

const BottomItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;
